import { render, staticRenderFns } from "./announcement-list.vue?vue&type=template&id=321a31e3&scoped=true"
import script from "./announcement-list.vue?vue&type=script&lang=ts"
export * from "./announcement-list.vue?vue&type=script&lang=ts"
import style0 from "./announcement-list.vue?vue&type=style&index=0&id=321a31e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a31e3",
  null
  
)

export default component.exports